import styled from 'styled-components';
import { Flexbox } from '@/components/flex';
import { DefaultTypography } from '@/components/typography';
import { DeviceType } from '@/utils/definitions';

export const InlineVariantsLayoutAllocationWrapper = styled(Flexbox)`
  && {
    position: relative;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    background: ${(p) => p.bg || `#f2f4f6`};
    border-radius: 1rem;
    border: 2px solid
      ${(p: any) =>
        // eslint-disable-next-line no-nested-ternary
        p.isActive ? `#0085FF;` : p.bg ? `#cdd3d9` : `transparent`};
  }
`;

export const InlineVariantsLayoutAllocationText = styled(DefaultTypography)`
  && {
    display: flex;
    align-items: center;
    padding: 1.5rem 2rem;
    font-family: 'Inter', serif;
    font-size: 1.4rem;
    font-weight: 600;
    color: #5b656e;
  }
`;

export const InlineVariantsLayoutAllocationInput = styled.input`
  pointer-events: auto;
  outline: none;
  height: ${({ device }: { device: DeviceType }) =>
    device === DeviceType.Desktop ? `4.5rem` : `4.5rem`};
  width: ${({ device }: { device: DeviceType }) =>
    device === DeviceType.Desktop ? `7rem` : `7rem`};
  border: 1.5px solid #c7c8cf;
  border-radius: 10px;
  box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  font-family: Inter, serif;
  font-weight: 600;
  color: #5b656e;
  font-size: ${({ device }: { device: DeviceType }) =>
    device === DeviceType.Desktop ? `1.5rem` : `1.5rem`};
`;
